/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Local_HintInputs */

const th_meeting_local_hint = /** @type {(inputs: Meeting_Local_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เริ่มกล้องหรือแชร์หน้าจอ ภาพตัวอย่างของคุณไม่มีเสียง`)
};

const en_meeting_local_hint = /** @type {(inputs: Meeting_Local_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start your camera or share your screen. Your preview is silent.`)
};

const ja_meeting_local_hint = /** @type {(inputs: Meeting_Local_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カメラを開始するか画面を共有してください。プレビューは無音です。`)
};

const zh_meeting_local_hint = /** @type {(inputs: Meeting_Local_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开摄像头或共享屏幕。你的预览是静音的。`)
};

const es_meeting_local_hint = /** @type {(inputs: Meeting_Local_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enciende la cámara o comparte tu pantalla. Tu vista previa está en silencio.`)
};

const pt_meeting_local_hint = /** @type {(inputs: Meeting_Local_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ligue sua câmera ou compartilhe sua tela. Sua prévia fica sem som.`)
};

const id_meeting_local_hint = /** @type {(inputs: Meeting_Local_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mulai kamera Anda atau bagikan layar. Pratinjau Anda dibisukan.`)
};

const fr_meeting_local_hint = /** @type {(inputs: Meeting_Local_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Démarrez votre caméra ou partagez votre écran. Votre aperçu est muet.`)
};

const tl_meeting_local_hint = /** @type {(inputs: Meeting_Local_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Simulan ang camera mo o ibahagi ang screen mo. Naka-mute ang preview mo.`)
};

const vi_meeting_local_hint = /** @type {(inputs: Meeting_Local_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bật máy ảnh hoặc chia sẻ màn hình. Bản xem trước của bạn đang tắt tiếng.`)
};

const ko_meeting_local_hint = /** @type {(inputs: Meeting_Local_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`카메라를 켜거나 화면을 공유하세요. 미리보기는 음소거되어 있습니다.`)
};

const de_meeting_local_hint = /** @type {(inputs: Meeting_Local_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starte deine Kamera oder teile deinen Bildschirm. Deine Vorschau ist stumm.`)
};

const ru_meeting_local_hint = /** @type {(inputs: Meeting_Local_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Включите камеру или поделитесь экраном. Ваш предпросмотр без звука.`)
};

const tr_meeting_local_hint = /** @type {(inputs: Meeting_Local_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kameranızı açın ya da ekranınızı paylaşın. Önizlemeniz sessiz.`)
};

const it_meeting_local_hint = /** @type {(inputs: Meeting_Local_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attiva la fotocamera o condividi lo schermo. La tua anteprima è muta.`)
};

const pl_meeting_local_hint = /** @type {(inputs: Meeting_Local_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Włącz kamerę albo udostępnij ekran. Twój podgląd jest wyciszony.`)
};

const uk_meeting_local_hint = /** @type {(inputs: Meeting_Local_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Увімкніть камеру або поділіться екраном. Ваш перегляд без звуку.`)
};

const hi_meeting_local_hint = /** @type {(inputs: Meeting_Local_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपना कैमरा चालू करें या स्क्रीन साझा करें। आपका पूर्वावलोकन मौन है।`)
};

const ar_meeting_local_hint = /** @type {(inputs: Meeting_Local_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`شغّل كاميرتك أو شارك شاشتك. معاينتك صامتة.`)
};

const ms_meeting_local_hint = /** @type {(inputs: Meeting_Local_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hidupkan kamera anda atau kongsi skrin. Pratonton anda disenyapkan.`)
};

const bn_meeting_local_hint = /** @type {(inputs: Meeting_Local_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ক্যামেরা চালু করুন বা পর্দা ভাগ করুন। আপনার প্রিভিউ নিঃশব্দ।`)
};

const zh_tw2_meeting_local_hint = /** @type {(inputs: Meeting_Local_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開啟你的相機或分享螢幕。你的預覽是靜音的。`)
};

const zh_hk2_meeting_local_hint = /** @type {(inputs: Meeting_Local_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開啟你的相機或分享熒幕。你的預覽是靜音的。`)
};

const ur_meeting_local_hint = /** @type {(inputs: Meeting_Local_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اپنا کیمرا چالو کریں یا اسکرین شیئر کریں۔ آپ کا پیش منظر خاموش ہے۔`)
};

const fa_meeting_local_hint = /** @type {(inputs: Meeting_Local_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دوربین‌تان را روشن کنید یا صفحه را هم‌رسانی کنید. پیش‌نمایش شما بی‌صداست.`)
};

const sw_meeting_local_hint = /** @type {(inputs: Meeting_Local_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Washa kamera yako au shiriki skrini. Onyesho lako halina sauti.`)
};

const nl_meeting_local_hint = /** @type {(inputs: Meeting_Local_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zet je camera aan of deel je scherm. Je eigen beeld staat op stil.`)
};

/**
* | output |
* | --- |
* | "Start your camera or share your screen. Your preview is silent." |
*
* @param {Meeting_Local_HintInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const meeting_local_hint = /** @type {((inputs?: Meeting_Local_HintInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Local_HintInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_meeting_local_hint(inputs)
	if (locale === "ja") return ja_meeting_local_hint(inputs)
	if (locale === "zh") return zh_meeting_local_hint(inputs)
	if (locale === "es") return es_meeting_local_hint(inputs)
	if (locale === "pt") return pt_meeting_local_hint(inputs)
	if (locale === "id") return id_meeting_local_hint(inputs)
	if (locale === "fr") return fr_meeting_local_hint(inputs)
	if (locale === "tl") return tl_meeting_local_hint(inputs)
	if (locale === "vi") return vi_meeting_local_hint(inputs)
	if (locale === "ko") return ko_meeting_local_hint(inputs)
	if (locale === "de") return de_meeting_local_hint(inputs)
	if (locale === "ru") return ru_meeting_local_hint(inputs)
	if (locale === "tr") return tr_meeting_local_hint(inputs)
	if (locale === "it") return it_meeting_local_hint(inputs)
	if (locale === "pl") return pl_meeting_local_hint(inputs)
	if (locale === "uk") return uk_meeting_local_hint(inputs)
	if (locale === "hi") return hi_meeting_local_hint(inputs)
	if (locale === "ar") return ar_meeting_local_hint(inputs)
	if (locale === "ms") return ms_meeting_local_hint(inputs)
	if (locale === "bn") return bn_meeting_local_hint(inputs)
	if (locale === "zh-TW") return zh_tw2_meeting_local_hint(inputs)
	if (locale === "zh-HK") return zh_hk2_meeting_local_hint(inputs)
	if (locale === "ur") return ur_meeting_local_hint(inputs)
	if (locale === "fa") return fa_meeting_local_hint(inputs)
	if (locale === "sw") return sw_meeting_local_hint(inputs)
	if (locale === "nl") return nl_meeting_local_hint(inputs)
	return en_meeting_local_hint(inputs)
});